import { useQuery } from "@tanstack/react-query";

import api from "@app/analytics/MeetingReport/api";
import type { ResponseError } from "@app/common/api";
import type { BaseSessionChapter } from "@app/common/types";
import { hasRetryableStatus } from "@app/common/utils";

const EMPTY_CHAPTERS: BaseSessionChapter[] = [];

const useSessionChaptersQuery = (
  sessionId?: string,
  opts = { enabled: true }
) => {
  const { data: chapters, isLoading } = useQuery({
    queryKey: ["chapters", sessionId],
    queryFn: () => api.data.getSessionChapters(sessionId!),
    enabled: opts.enabled && Boolean(sessionId),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    // don't retry if user is not authorized to fetch chapters
    retry: (failureCount, error: ResponseError) =>
      failureCount < 3 && hasRetryableStatus(error),
  });

  return {
    chapters: chapters ?? EMPTY_CHAPTERS,
    isLoading,
  };
};

export default useSessionChaptersQuery;
